import { inject, shallowRef } from 'vue'

export function useDecisionApi() {
  const API_DOMAIN_DECISION = inject('BEDMATPICK_API_DOMAIN_DECISION')

  /** METHODS */
  let sendDecisionAbortController
  const isSendDecisionPending = shallowRef(false)
  const sendDecision = async (body, enableAbortSignal = false) => {
    if (enableAbortSignal) {
      if (sendDecisionAbortController) {
        sendDecisionAbortController.abort()
      }
      sendDecisionAbortController = new AbortController()
    }

    const signal = sendDecisionAbortController ? sendDecisionAbortController.signal : undefined
    isSendDecisionPending.value = true

    return await fetch(new URL(`/v1/decision`, API_DOMAIN_DECISION), {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'content-type': 'application/json'
      },
      body: JSON.stringify(body),
      signal
    }).finally(() => {
      //  Only reset pending if the signal was NOT aborted
      if (!signal?.aborted) {
        isSendDecisionPending.value = false
      }
    })
  }

  return { sendDecision, isSendDecisionPending }
}
